export { default as ic_quit } from "./ic_quit.svg?react";
